export default "__VITE_IMAGE_ASSET__450b40b5__";